import React from 'react'
import styled from 'styled-components'
import criticalIcon from '@/assets/critical_icon.svg'

const StyledError = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25em;
  background-color: ${({ theme }) => theme.colors.system.critical.surface};
  border: 1px solid ${({ theme }) => theme.colors.system.critical.border};
  border-radius: 16px;
  padding: 0.25em 1em;

  > img {
    width: 1em;
    height: 1em;
  }
`

interface Props {
  error: React.ReactNode
}

export const ErrorDetail: React.FC<Props> = ({ error }) => {
  return (
    <StyledError>
      <img src={criticalIcon} />
      <p>{error}</p>
    </StyledError>
  )
}
